module.exports = __webpack_public_path__ + "static/media/caret-left.93169868.svg";